{
  "welcome": {
    "title": {
      "part1": "Sua melhor companhia para um ",
      "part2": "estilo de vida",
      "part3": " sóbrio"
    },
    "button": {
      "start": "Continuar com meu e-mail",
      "login": "Acessar minha conta",
      "google": "Continuar com o Google"
    },
    "divider": {
      "or": "Ou"
    },
    "google": {
      "errorTitle": "Não foi possível continuar",
      "errorMessage": "Houve um problema ao entrar com o Google. Tente novamente."
    }
  },
  "auth": {
    "login": {
      "title": "Entrar",
      "welcomeBack": "Faça seu login para acessar sua conta",
      "welcomeBackReturning": "É ótimo ter você de volta ao Padrinho!",
      "member": "Membro",
      "switchUser": "Trocar",
      "email": "E-mail",
      "emailPlaceholder": "seu@email.com",
      "password": "Senha",
      "passwordPlaceholder": "Digite sua senha",
      "button": "Entrar",
      "forgot": "Esqueceu a senha?",
      "forgotPassword": "Esqueceu a senha?",
      "errorTitle": "Erro",
      "errorFillFields": "Por favor, preencha todos os campos",
      "errorInvalidCredentials": "Credenciais inválidas",
      "errorEmailNotConfirmed": "E-mail não confirmado",
      "errorTooManyAttempts": "Muitas tentativas de login. Tente novamente em alguns minutos.",
      "errorConnection": "Erro de conexão",
      "errorRetry": "Tentar novamente",
      "errorCancel": "Cancelar",
      "errorConfig": "Configuração",
      "errorTemporary": "Erro temporário no servidor. Tente novamente mais tarde.",
      "errorUnexpected": "Erro inesperado",
      "errorUnexpectedMessage": "Erro inesperado. Tente novamente."
    },
    "forgotPassword": {
      "title": "Redefinir senha",
      "subtitle": "Digite seu e-mail para receber as instruções de redefinição de senha",
      "email": "E-mail",
      "emailPlaceholder": "seu@email.com",
      "button": "Enviar instruções",
      "buttonLoading": "Enviando...",
      "errorTitle": "Erro",
      "errorEmail": "Por favor, digite seu e-mail",
      "errorRateLimit": "Limite de tentativas excedido",
      "errorRateLimitMessage": "Muitas tentativas de redefinição de senha foram feitas. Aguarde alguns minutos antes de tentar novamente.",
      "errorUserNotFound": "E-mail não encontrado",
      "errorUserNotFoundMessage": "Não encontramos uma conta com este e-mail",
      "successTitle": "E-mail enviado",
      "successMessage": "Verifique sua caixa de entrada para redefinir sua senha",
      "successButton": "OK",
      "errorUnexpected": "Ocorreu um erro inesperado"
    },
    "resetPassword": {
      "title": "Nova senha",
      "subtitle": "Digite uma nova senha para sua conta",
      "newPassword": "Nova senha",
      "confirmPassword": "Confirmar senha",
      "newPasswordPlaceholder": "Digite sua nova senha",
      "confirmPasswordPlaceholder": "Confirme sua nova senha",
      "button": "Redefinir senha",
      "buttonLoading": "Atualizando...",
      "errorTitle": "Erro",
      "errorFillFields": "Por favor, preencha todos os campos",
      "errorPasswordMismatch": "As senhas não coincidem",
      "errorInvalidPassword": "Senha Inválida",
      "errorPasswordRequirements": "Sua senha deve atender aos seguintes requisitos:\n\n• Mínimo 8 caracteres\n• Uma letra maiúscula\n• Uma letra minúscula\n• Um número",
      "errorGeneric": "Falha ao redefinir senha",
      "successTitle": "Senha alterada",
      "successMessage": "Sua senha foi alterada com sucesso!",
      "successButton": "OK",
      "errorUnexpected": "Ocorreu um erro inesperado"
    },
    "verifyCode": {
      "title": "Digite o código de verificação",
      "subtitle": "Enviamos um código de 6 dígitos para o e-mail {email}",
      "button": "Verificar",
      "resendButton": "Reenviar código",
      "resendIn": "Reenviar em {timer}",
      "contactEmail": "contato@padrinho.app",
      "contactMessage": "Revise o e-mail utilizado ou entre em contato:",
      "errorTitle": "Erro",
      "successTitle": "Sucesso",
      "errorDigits": "Por favor, digite o código de 6 dígitos",
      "errorInvalidCode": "Código inválido ou expirado",
      "errorVerification": "Erro na verificação. Tente novamente.",
      "errorResend": "Erro ao reenviar código. Tente novamente.",
      "successResend": "Sucesso",
      "successResendMessage": "Código reenviado com sucesso!",
      "errorUnexpected": "Erro inesperado. Tente novamente."
    },
    "setPassword": {
      "title": "Crie sua senha pessoal",
      "subtitle": "Defina uma senha forte para proteger sua conta e acessar todos os recursos do Padrinho",
      "password": "Senha",
      "confirmPassword": "Confirme sua senha",
      "placeholder": "****",
      "button": "Criar conta",
      "buttonLoading": "Criando conta...",
      "requirementsTitle": "Sua senha deve ter:",
      "requirementMinLength": "Mínimo 8 letras",
      "requirementUppercase": "Uma letra maiúscula",
      "requirementLowercase": "Uma letra minúscula",
      "requirementNumber": "Um número",
      "errorTitle": "Erro",
      "errorPasswordMismatch": "As senhas não coincidem",
      "errorInvalidPassword": "Senha Inválida",
      "errorPasswordRequirements": "Sua senha deve atender aos seguintes requisitos",
      "errorAccessRequired": "Acesso Necessário",
      "errorAccessRequiredMessage": "Por favor, complete o processo de verificação por email.",
      "errorInvalidAccess": "Acesso Inválido",
      "errorInvalidAccessMessage": "Por favor, complete novamente o processo de verificação.",
      "errorSessionExpired": "Sua sessão expirou. Você será redirecionado para começar novamente.",
      "errorWeakPassword": "Senha muito fraca. Por favor, escolha uma senha mais forte com pelo menos 8 caracteres, incluindo maiúsculas, minúsculas e números.",
      "errorNetwork": "Erro de conexão com a internet. Verifique sua conexão e tente novamente.",
      "errorTimeout": "A operação demorou muito. Por favor, verifique sua conexão e tente novamente.",
      "errorSessionNotReceived": "Houve um problema ao estabelecer sua sessão. Por favor, tente novamente.",
      "errorGeneric": "Erro ao criar sua conta. Por favor, tente novamente.",
      "errorSetPassword": "Erro ao definir senha. Por favor, tente novamente."
    },
    "sessionExpired": {
      "title": "Sessão expirada",
      "message": "Sua sessão expirou. Faça login novamente para continuar.",
      "button": "Entrar"
    }
  },
  "onboarding": {
    "title": "Comece por aqui",
    "sobrietySet": "Definir tempo de sobriedade",
    "firstMessage": "Iniciar conversa com o Bill",
    "firstCheckin": "Ir no primeiro encontro online",
    "firstTrailStep": "Iniciar trilha de recuperação",
    "firstDiaryNote": "Registrar no meu diário",
    "profilePhoto": "Colocar minha foto de perfil",
    "firstMessagePrompt": "Olá Bill, como você pode me ajudar?",
    "header": "Onboarding",
    "welcome": {
      "title": "Sua trilha para uma vida em sobriedade se inicia hoje!",
      "subtitle": "Aqui no app você encontrará várias ferramentas excelentes para te apoiar em seu progresso",
      "button": "Ok, vamos lá!",
      "features": {
        "bill": "Bill, seu assistente pessoal",
        "billDesc": "Conversas inteligentes 24/7 para apoio e orientação",
        "diary": "Diário & Check-ins",
        "diaryDesc": "Registre pensamentos, sentimentos e participações em encontros online",
        "clock": "Relógio de Sobriedade",
        "clockDesc": "Marque seu progresso em tempo e celebre cada conquista",
        "progress": "Progresso em Tempo Real",
        "progressDesc": "Acompanhe sua evolução dia a dia",
        "connection": "Conexão com Clínicas",
        "connectionDesc": "Comunicação direta com a sua clínica provedora",
        "privacy": "Privacidade Total",
        "privacyDesc": "Seus dados são protegidos e confidenciais"
      }
    },
    "name": {
      "title": "Para começar, como podemos te chamar?",
      "subtitle": "Você pode escolher um apelido",
      "placeholder": "Digite seu nome ou apelido",
      "required": "Nome necessário",
      "requiredMessage": "Por favor, digite seu nome ou apelido.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar seu nome. Tente novamente."
    },
    "interests": {
      "title": "Quais temas você tem interesse?",
      "titleWithName": "quais temas você tem interesse?",
      "subtitle": "Escolha pelo menos 3 tópicos de interesse",
      "insufficient": "Seleção Insuficiente",
      "insufficientMessage": "Por favor, escolha pelo menos 3 tópicos de interesse.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar seus interesses. Tente novamente."
    },
    "gender": {
      "title": "Qual é o seu gênero?",
      "subtitle": "Selecione a opção que melhor te representa",
      "feminine": "Feminino",
      "masculine": "Masculino",
      "nonBinary": "Não-binário",
      "preferNotToSay": "Prefiro não dizer",
      "required": "Seleção Necessária",
      "requiredMessage": "Por favor, selecione uma opção.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar sua preferência. Tente novamente."
    },
    "supportRecipient": {
      "title": "Hoje, você está buscando apoio para?",
      "subtitle": "Selecione a opção que melhor descreve sua situação",
      "self": "Para mim",
      "friend": "Para um(a) amigo(a)",
      "family": "Para um familiar",
      "required": "Seleção Necessária",
      "requiredMessage": "Por favor, selecione uma opção.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar sua preferência. Tente novamente."
    },
    "sponsorship": {
      "title": "Você gostaria de ter um padrinho?",
      "subtitle": "Escolha uma opção sobre apadrinhamento",
      "godmother": "Sim, uma madrinha",
      "godfather": "Sim, um padrinho",
      "maybeLater": "Talvez depois",
      "dontWant": "Não quero",
      "required": "Seleção Necessária",
      "requiredMessage": "Por favor, selecione uma opção.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar sua preferência. Tente novamente."
    },
    "addictionType": {
      "title": "Que tipo de dependência você se identifica atualmente?",
      "subtitle": "Você pode selecionar mais de 1 opção",
      "options": {
        "alcohol": "Álcool",
        "nicotine": "Nicotina",
        "drugs": "Drogas / Psicoativos",
        "gambling": "Jogos",
        "sex": "Sexo",
        "pornography": "Pornografia",
        "other": "Outros"
      },
      "required": "Seleção Necessária",
      "requiredMessage": "Por favor, selecione pelo menos uma opção.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar sua seleção. Tente novamente."
    },
    "frequency": {
      "title": "Com que frequência você recorre a sua dependência?",
      "options": {
        "onceWeek": "1 vez na semana",
        "twoThreeWeek": "2 a 3 vezes na semana",
        "fourFiveWeek": "4 a 5 vezes na semana",
        "daily": "Todos os dias",
        "alreadySober": "Já estou em sobriedade",
        "notAddicted": "Não sou dependente"
      },
      "required": "Seleção Necessária",
      "requiredMessage": "Por favor, selecione uma opção.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar sua seleção. Tente novamente."
    },
    "goal": {
      "title": "Qual o seu principal objetivo dentro do Padrinho?",
      "options": {
        "reduceControl": "Reduzir ou controlar o comportamento compulsivo",
        "fullAbstinence": "Alcançar a abstinência completa",
        "maintainSobriety": "Manter sobriedade ou equilíbrio diário",
        "identifyTriggers": "Identificar gatilhos e construir estratégias de enfrentamento",
        "healthyHabits": "Desenvolver hábitos saudáveis como substitutos",
        "rebuildRelationships": "Reconstruir ou fortalecer relações e redes de apoio",
        "monitorProgress": "Monitorar o próprio progresso e celebrar pequenas vitórias"
      },
      "required": "Seleção Necessária",
      "requiredMessage": "Por favor, selecione uma opção.",
      "error": "Erro",
      "errorMessage": "Não foi possível salvar sua seleção. Tente novamente."
    },
    "notifications": {
      "title": "Podemos te enviar algumas notificações?",
      "subtitle": "Só pra criarmos um vínculo legal, não vamos te enviar SPAMs, prometemos!",
      "button": "Claro! Pode enviar"
    },
    "success": {
      "welcomeMessage": "{name}, te damos as boas-vindas ao Padrinho!",
      "welcomeMessageFallback": "Nome, te damos as boas-vindas ao Padrinho!",
      "recoveryMessage": "Sua recuperação continua hoje, {date}",
      "buttonStart": "Começar",
      "buttonRetry": "Tentar Novamente",
      "greeting": "Que bom que você chegou,",
      "joinPrefix": "Junte-se a ",
      "joinHighlight": "mais de {count} pessoas online",
      "joinSuffix": " agora para trocas e apoio",
      "uploadPhoto": "Incluir minha foto de perfil",
      "uploading": "Enviando foto...",
      "buttonContinue": "Ok, vamos lá!"
    },
    "firstAccess": {
      "stepNumber": "6",
      "title": "Conecte-se ao Padrinho",
      "subtitle": "Insira o e-mail que você usará para acessar a sua conta no Padrinho",
      "emailLabel": "E-mail",
      "emailPlaceholder": "Digite seu e-mail",
      "termsTitle": "Termos e Políticas de Privacidade",
      "termsAccept": "Aceito os ",
      "termsLink": "termos e políticas de privacidade",
      "termsAppName": " do app Padrinho.",
      "errors": {
        "emailRequired": "Erro",
        "emailRequiredMessage": "Por favor, digite seu e-mail",
        "emailInvalid": "Erro",
        "emailInvalidMessage": "Por favor, digite um e-mail válido",
        "termsRequired": "Erro",
        "termsRequiredMessage": "Você deve aceitar os termos para continuar",
        "userExists": "Conta Existente",
        "userExistsMessage": "Já existe uma conta com este e-mail. Por favor, faça login usando sua senha.",
        "cancel": "Cancelar",
        "goToLogin": "Ir para Login",
        "sendError": "Erro",
        "sendErrorMessage": "Erro ao enviar código de verificação. Tente novamente.",
        "unexpectedError": "Erro",
        "unexpectedErrorMessage": "Erro inesperado. Tente novamente."
      }
    }
  },
  "sobriety": {
    "card": {
      "title": "Relógio de sobriedade",
      "setupDescription": "Conte os seus dias em sobriedade",
      "todayLabel": "Hoje, {day} de {month}",
      "hoursLabel": "+ 24 horas",
      "daysMessage": "Você está a {days} {daysWord} em sobriedade!",
      "day": "dia",
      "days": "dias",
      "congratsTitle": "Parabéns! Você se manteve em sobriedade",
      "year": "ano",
      "years": "anos",
      "month": "mês",
      "months": "meses",
      "dayLabel": "dia",
      "daysLabel": "dias",
      "hour": "hora",
      "hours": "horas",
      "share": "Compartilhar",
      "restart": "Recomeçar",
      "edit": "Editar",
      "totalDaysMessage": "Você está a {days} dias em sobriedade",
      "totalDaysPrefix": "Você está a ",
      "totalDaysSuffix": " em sobriedade",
      "totalDaysWord": "dias",
      "addWidget": "Adicionar ao início"
    },
    "share": {
      "message": "Estou há {days} dias em sobriedade! 🎉 #Padrinho #Sobriedade",
      "imageText": "Hoje estou completando\n{days} dias em sobriedade"
    },
    "clock": {
      "title": "Relógio de sobriedade",
      "cancel": "Cancelar",
      "question": "Conta pra gente qual é o seu momento atual",
      "option1": "Tive uma recaída e estou recomeçando",
      "option2": "Já estou sóbrio a um tempo",
      "option3": "Estou iniciando hoje",
      "continue": "Continuar"
    },
    "input": {
      "title": "Relógio de sobriedade",
      "subtitle": "Quando foi a última vez que você bebeu?",
      "placeholder": "DD/MM/AAAA",
      "helperText": "Digite a data no formato DD/MM/AAAA",
      "daysLabel": "Dias de sobriedade",
      "button": "Começar a contar",
      "invalidDate": "Data inválida",
      "futureDate": "A data não pode ser no futuro"
    },
    "relapse": {
      "title": "Relógio de sobriedade",
      "mainTitle": "Lembre-se, recaídas fazem parte do processo",
      "subtitle": "O mais importante são suas conquistas e aprendizados até hoje",
      "reminderButton": "Escreva um lembrete",
      "continueButton": "Continuar",
      "noteTitle": "Lembrete sobre recaída"
    },
    "congratulations": {
      "title": "Relógio de sobriedade",
      "mainTitle": "Parabéns! Hoje você inicia um momento importante em sua trilha",
      "subtitle": "Lembre-se, o importante são suas conquistas e aprendizados até hoje",
      "button": "Ok, vamos lá!"
    },
    "shareCard": {
      "line1": "Hoje estou completando",
      "days": "dias",
      "line2": "em sobriedade"
    },
    "sharePage": {
      "title": "Relógio de sobriedade",
      "shareButton": "Enviar por mensagem",
      "saveButton": "Baixar",
      "sharing": "Compartilhando...",
      "saving": "Salvando...",
      "savedTitle": "Imagem salva",
      "savedMessage": "A imagem foi salva na sua galeria",
      "errorTitle": "Erro",
      "errorMessage": "Não foi possível processar a imagem. Tente novamente.",
      "permissionDeniedTitle": "Permissão negada",
      "permissionDeniedMessage": "Precisamos de permissão para salvar na galeria",
      "sharingUnavailableTitle": "Compartilhamento indisponível",
      "sharingUnavailableMessage": "O compartilhamento não está disponível neste dispositivo",
      "shareDialogTitle": "Compartilhar conquista"
    }
  },
  "navbar": {
    "bill": "Bill",
    "meetings": "Encontros"
  },
  "bill": {
    "welcome": {
      "title": "Olá, eu sou o Bill",
      "subtitle": "Seu padrinho digital"
    },
    "loading": {
      "connecting": "Bill está respondendo...",
      "typing": "Digitando..."
    },
    "suggestions": {
      "startTrail": "Iniciar a minha trilha",
      "diaryGuide": "Como utilizar meu diário",
      "meetingTimes": "Horários de reuniões"
    },
    "input": {
      "placeholder": "Mande sua mensagem para o Bill"
    },
    "plusBar": {
      "continueConversation": "Continue conversando com o Bill",
      "remainingMessages": "Você ainda tem ",
      "remainingMessagesEnd": " mensagens",
      "sendMessage": "Mande sua mensagem para o Bill"
    },
    "errors": {
      "technicalIssue": "Desculpe, tive um problema técnico ao processar sua mensagem. Pode tentar novamente?",
      "monthlyLimitReached": "Você atingiu seu limite de mensagens do mês. Atualize para o Padrinho Plus para conversar ilimitadamente com o Bill."
    }
  },
  "chat": {
    "title": "Bill - Seu Assistente",
    "placeholder": "Escreva sua mensagem...",
    "send": "Enviar",
    "typing": "Bill está digitando...",
    "empty": "Comece uma conversa com Bill",
    "error": "Erro ao enviar mensagem",
    "connecting": "Conectando com Bill...",
    "messageTitle": "Mensagem do Bill",
    "today": "Hoje",
    "yesterday": "Ontem",
    "suggestedActions": {
      "startTrail": "Iniciar a minha trilha",
      "diaryGuide": "Como utilizar meu diário"
    },
    "contextMenu": {
      "share": "Compartilhar",
      "bookmark": "Salvar",
      "remove": "Remover",
      "edit": "Editar"
    },
    "clearConversation": {
      "title": "Nova conversa",
      "message": "Isso vai limpar sua conversa atual com o Bill. Suas mensagens salvas no diário serão mantidas. Você pode recomeçar a qualquer momento.",
      "confirm": "Iniciar nova conversa"
    }
  },
  "diary": {
    "headerTitle": "Diário",
    "title": "Diário de Bem-Estar",
    "tabs": {
      "relogio": "Relógio",
      "notas": "Notas",
      "missoes": "Missões"
    },
    "clock": {
      "emptyTitle": "Acompanhe seus dias em sobriedade",
      "startButton": "Iniciar contagem",
      "communityCount": "Você e {count} pessoas estão em sobriedade",
      "share": "Compartilhar",
      "restart": "Recomeçar",
      "edit": "Editar",
      "anos": "Anos",
      "meses": "Meses",
      "dias": "Dias",
      "horas": "Horas",
      "shareMessage": "dias em sobriedade! 🎉 #Padrinho"
    },
    "addEntry": "Nova Entrada",
    "mood": "Como você está se sentindo?",
    "gratitude": "O que você é grato?",
    "notes": "Anotações",
    "save": "Salvar",
    "delete": "Deletar",
    "empty": "Nenhuma entrada ainda",
    "emptyState": {
      "title": "Salve suas memórias ao longo da sua trilha",
      "subtitle": "Aqui você pode registrar pensamentos, sentimentos ou salvar mensagens do Bill para se recordar no futuro",
      "notesTitle": "Registre uma reflexão para hoje",
      "notesButton": "Criar nota"
    },
    "today": "Hoje",
    "yesterday": "Ontem",
    "noteDeleted": "Anotação excluída com sucesso!",
    "checkinRemoved": "Check-in removido com sucesso!",
    "checkinHidden": "Check-in ocultado do diário com sucesso!",
    "relapseHidden": "Registro ocultado do diário com sucesso!",
    "messageRemoved": "Mensagem removida do diário com sucesso!",
    "relapse": {
      "title": "Recomeçar",
      "message": "Recaídas fazem parte do processo! Continue de onde parou"
    },
    "deleteError": "Erro ao excluir. Tente novamente.",
    "removeMessageError": "Erro ao remover mensagem. Tente novamente.",
    "sentimentLabel": "Sentimento",
    "contextLabel": "Contexto",
    "checkinText": "Check-in 📍 Você participou do encontro {meetingName} às {time}",
    "filters": {
      "author": "Autor",
      "period": "Período",
      "sentiment": "Sentimento",
      "sentimentMultiple": "{count} sentimentos",
      "you": "Você",
      "bill": "Bill",
      "last7days": "Últimos 7 dias",
      "last15days": "Últimos 15 dias",
      "last30days": "Últimos 30 dias",
      "all": "Todos",
      "search": "Buscar em suas anotações..."
    },
    "actions": {
      "options": "Opções",
      "editEntry": "Editar registro",
      "deleteEntry": "Excluir registro",
      "editNote": "Editar nota",
      "deleteNote": "Excluir nota",
      "removeCheckin": "Remover check-in",
      "hideFromDiary": "Ocultar do diário",
      "removeFromDiary": "Remover do diário"
    },
    "buttons": {
      "sentiment": "Sentimento",
      "note": "Anotação"
    },
    "search": {
      "cancel": "Cancelar",
      "results": "{count} resultado encontrado",
      "resultsPlural": "{count} resultados encontrados"
    },
    "emotions": {
      "feliz": "Feliz",
      "animado": "Animado",
      "tranquilo": "Tranquilo",
      "cansado": "Cansado",
      "frustrado": "Frustrado",
      "triste": "Triste",
      "estressado": "Estressado",
      "irritado": "Irritado",
      "ansioso": "Ansioso"
    },
    "categories": {
      "vida-pessoal": "Vida Pessoal",
      "trabalho": "Trabalho",
      "relacionamentos": "Relacionamentos",
      "saude": "Saúde",
      "financas": "Finanças",
      "sobriedade": "Sobriedade",
      "lazer": "Lazer",
      "espiritualidade": "Espiritualidade",
      "educacao": "Educação",
      "outros": "Outros",
      "and": "e"
    },
    "sentiment": {
      "title": "Sentimento",
      "question": "Como você está se sentindo hoje?",
      "nextButton": "Avançar",
      "writeMemory": "Escreva uma memória sobre esse sentimento",
      "context": "Em que contexto você se sente assim?",
      "savedSuccess": "registrado com sucesso! 💚",
      "noteSavedSuccess": "Anotação salva com sucesso!",
      "noteUpdatedSuccess": "Anotação atualizada com sucesso!",
      "cannotEdit": "Check-ins não podem ser editados, apenas removidos.",
      "removed": "Check-in removido com sucesso!",
      "hidden": "Check-in ocultado do diário com sucesso!",
      "deleted": "Registro de sentimento excluído com sucesso!",
      "error": "Erro ao excluir registro. Tente novamente.",
      "removeError": "Erro ao remover mensagem. Tente novamente.",
      "placeholderWithCategory": "Estou {emotion} com {category}...",
      "placeholderNoCategory": "Estou me sentindo {emotion}...",
      "contextLabel": "Contexto:"
    },
    "addNote": {
      "titleNew": "Nova anotação",
      "titleEdit": "Editar anotação",
      "titleEditEntry": "Editar registro",
      "placeholder": "O que está em sua mente agora?",
      "userFallback": "Usuário"
    }
  },
  "meetings": {
    "title": "Encontros",
    "tabs": {
      "explore": "Explore",
      "saved": "Salvos",
      "para_voce": "Para você"
    },
    "salvos": {
      "empty": {
        "title": "Nenhum encontro salvo ainda",
        "subtitle": "Toque no coração de qualquer encontro para vê-lo aqui depois.",
        "cta": "Explorar encontros"
      }
    },
    "filters": {
      "time": "Horário",
      "day": "Dia da semana",
      "category": "Categoria",
      "clear": "Limpar filtros"
    },
    "time": {
      "todayAt": "Hoje às"
    },
    "sections": {
      "happeningNow": "Acontecendo agora",
      "suggested": "Sugeridos para você",
      "otherMeetings": "Outros encontros"
    },
    "empty": {
      "title": "Você ainda não salvou um encontro",
      "subtitle": "Salve um encontro para que você possa lembrá-lo depois!"
    },
    "search": {
      "placeholder": "Buscar por nome, tipo ou plataforma...",
      "cancelButton": "Cancelar",
      "results": "{count} resultado encontrado",
      "resultsPlural": "{count} resultados encontrados",
      "preset1": "Grupo Caminho",
      "preset2": "Partilhas"
    },
    "actions": {
      "favorite": "Favoritar",
      "favorited": "Favorito",
      "unfavorite": "Desfavoritar",
      "enter": "Entrar",
      "invite": "Convidar"
    },
    "sectionTitles": {
      "upcoming": "Próximos encontros"
    },
    "status": {
      "liveNow": "Ao vivo agora",
      "live": "Ao vivo"
    },
    "carousel": {
      "title": "Encontros online",
      "viewAll": "Ver todos",
      "loading": "Carregando próximos encontros...",
      "empty": "Nenhum encontro próximo encontrado"
    },
    "labels": {
      "password": "Senha",
      "schedule": "Horários",
      "place": "Plataforma",
      "participants": "Participantes"
    },
    "detail": {
      "infoTitle": "Informações do encontro",
      "totalParticipations": "check-ins no total",
      "liveNow": "Ao vivo agora",
      "at": "às",
      "tipsTitle": "Dicas para a reunião",
      "tipCamera": "Você não precisa abrir a câmera",
      "tipMute": "Você pode só ouvir, ninguém vai te chamar pelo nome",
      "tipHeart": "As pessoas são como você: melhorando um dia de cada vez",
      "tipHonesty": "Não existe certo ou errado — só sinceridade",
      "tipLeave": "Se sentir vontade, você pode sair da reunião a qualquer momento",
      "programacao": "Programação",
      "programacaoCount": "{count} encontros semanais",
      "programacaoCountOne": "1 encontro semanal",
      "programacaoSingleSession": "Sessão única",
      "programacaoRow": "{weekday} · {time} · {category}"
    },
    "form": {
      "title": {
        "new": "Novo Encontro",
        "edit": "Editar Encontro"
      },
      "fields": {
        "name": {
          "label": "Nome do Encontro *",
          "placeholder": "Ex: Círculo de Apoio Matinal"
        },
        "link": {
          "label": "Link do Encontro *",
          "placeholder": "https://zoom.us/j/123456789"
        },
        "time": {
          "label": "Horário *",
          "placeholder": "Ex: 08:00"
        },
        "category": {
          "label": "Categoria *"
        },
        "group": {
          "label": "Grupo",
          "noGroups": "Nenhum grupo disponível"
        },
        "weekdays": {
          "label": "Dias da Semana *"
        },
        "platform": {
          "label": "Plataforma *",
          "inPerson": "Presencial"
        },
        "period": {
          "label": "Período *"
        },
        "region": {
          "label": "Região",
          "placeholder": "Ex: São Paulo"
        },
        "password": {
          "label": "Senha da Reunião",
          "placeholder": "Senha opcional"
        },
        "description": {
          "label": "Descrição",
          "placeholder": "Descrição do encontro"
        },
        "headerImage": {
          "label": "URL da Imagem do Cabeçalho",
          "placeholder": "https://exemplo.com/imagem.jpg",
          "hint": "Cole a URL completa da imagem que aparecerá no cabeçalho do encontro"
        }
      },
      "categories": {
        "supportGroup": "Grupo de Apoio",
        "workshop": "Workshop",
        "meditation": "Meditação",
        "therapy": "Terapia",
        "sharing": "Partilha",
        "reuniaoNovos": "Reunião para Novos",
        "reuniaoPartilhas": "Reunião de Partilhas",
        "reuniaoTematica": "Reunião Temática",
        "reuniaoEstudoLiteratura": "Estudo de Literatura",
        "reuniaoAteusAgnosticos": "Ateus e Agnósticos",
        "reuniaoLgbtqiapn": "LGBTQIAPN+",
        "reuniaoCodependentes": "Codependentes",
        "reuniaoPassos": "Reunião de Passos",
        "reuniaoTradicoes": "Reunião de Tradições"
      },
      "platforms": {
        "zoom": "Zoom",
        "googleMeet": "Google Meet",
        "microsoftTeams": "Microsoft Teams",
        "jitsiMeet": "Jitsi Meet",
        "discord": "Discord",
        "inPerson": "Presencial"
      },
      "actions": {
        "cancel": "Cancelar",
        "saveChanges": "Salvar Alterações",
        "create": "Criar Encontro"
      }
    },
    "alerts": {
      "notFound": "Encontro não encontrado",
      "loadError": "Falha ao carregar encontro",
      "loginRequired": "É necessário fazer login para entrar no encontro",
      "linkNotAvailable": "Link do encontro não disponível",
      "fillRequired": "Por favor, preencha todos os campos obrigatórios e selecione pelo menos um dia da semana.",
      "saveError": "Falha ao salvar encontro",
      "saveSuccess": "Encontro adicionado com sucesso!",
      "updateSuccess": "Encontro atualizado com sucesso!",
      "genericError": "Ocorreu um erro ao salvar o encontro",
      "unauthorized": "Acesso não autorizado"
    },
    "share": {
      "greeting": "Olá! Gostaria de te convidar para participar de um encontro comigo. 🙏",
      "schedule": "Horários",
      "link": "Link",
      "password": "Senha",
      "downloadApp": "Ou baixe o app do Padrinho em www.padrinho.app/downloads"
    },
    "clipboard": {
      "passwordCopied": "Senha copiada!"
    },
    "errors": {
      "loading": "Erro ao carregar encontros",
      "loadingSaved": "Erro ao carregar encontros salvos",
      "updateSaved": "Erro ao atualizar encontro salvo",
      "loadMeetingInfo": "Não foi possível carregar as informações do encontro"
    },
    "errorLoading": "Erro ao carregar encontros",
    "errorLoadingSaved": "Erro ao carregar encontros salvos",
    "saved_success": "Tudo bem! Te avisaremos quando esse encontro começar.",
    "removed": "Encontro removido dos salvos!",
    "loginToSave": "Faça login para salvar encontros",
    "onboarding": {
      "welcome": {
        "title": "Olá {name}, te damos as boas-vindas aos encontros",
        "subtitle": "Aqui você poderá se conectar com pessoas que estão com o mesmo foco que você! Mas antes, algumas dicas para participar.",
        "cta": "Vamos lá!",
        "accordion1": {
          "title": "O que é um encontro?",
          "content": "Participar de uma reunião pode parecer difícil no começo, mas é um dos passos mais importantes para quem quer mudar de vida. As reuniões são espaços seguros onde pessoas como você compartilham experiências, força e esperança. Você ouve como elas lidaram com a dependência, como encontraram soluções para os conflitos do dia a dia e como estão construindo uma vida melhor hoje."
        },
        "accordion2": {
          "title": "O que acontece em um encontro?",
          "content": "Logo no início, o coordenador faz uma breve abertura e, em algumas reuniões, há um momento de silêncio ou a Oração da Serenidade. Você pode — se quiser — dizer que é sua primeira vez, mas isso não é obrigatório. Depois, ouvimos reflexões, partilhas e, ao final, há um momento de união ou uma leitura que reforça o compromisso coletivo.\n\nQuando a reunião termina, muitos ficam para conversar. Você decide se quer participar disso — sem pressão."
        },
        "accordion3": {
          "title": "Por que participar?",
          "content": "Ir a uma reunião não é apenas \"comparecer\"; é investir em você mesmo. Aqui estão benefícios imediatos que você pode sentir já na primeira participação:\n\n1. A reunião traz soluções reais para a vida diária.\nAo ouvir outras histórias, surgem novas perspectivas para lidar com conflitos, emoções e desafios que antes pareciam impossíveis.\n\n2. A reunião cria compromisso — e compromisso cria mudança.\nEntrar na sala, mesmo em silêncio, já é uma forma de quebrar a rotina antiga e construir um novo caminho.\n\n3. A reunião alivia a mente e o coração.\nFalar — ou apenas ouvir — ajuda a esvaziar a \"panela de pressão\" por dentro. Você sai mais leve, mais calmo e mais preparado."
        }
      },
      "step": "Pergunta {current} de {total}",
      "next": "Próxima",
      "back": "Voltar",
      "q1": {
        "question": "Para começar, você já participou de algum encontro de grupos anônimos antes?",
        "options": {
          "never": "Nunca participei",
          "once": "Participei uma vez",
          "few_times": "Participei algumas vezes",
          "long_periods": "Já participei por longos períodos",
          "for_someone": "Não é para mim, mas alguém próximo já participa"
        }
      },
      "q2": {
        "question": "O que trouxe você aqui nesse momento?",
        "options": {
          "iniciante": "Estou perdido e preciso entender se os encontros podem me ajudar.",
          "novo": "Já ouvi falar dos encontros e quero saber como funciona antes de entrar.",
          "visitante": "Já fui em um encontro mas não tive uma boa experiência.",
          "recaido": "Estou querendo recomeçar depois de uma recaída.",
          "itinerante": "Procuro um encontro de qualidade para manter minha sobriedade.",
          "codependente": "Estou aqui por alguém que eu amo."
        }
      },
      "q3": {
        "question": "O que você mais precisa agora?",
        "options": {
          "courage": "Coragem para dar o primeiro passo",
          "information": "Informação sobre como funciona",
          "emotional_support": "Apoio emocional de pessoas que entendem",
          "talk_to_others": "Falar com outras pessoas em recuperação",
          "recovery_after_relapse": "Recuperar forças após uma recaída",
          "learn_to_help": "Aprender como ajudar alguém que eu amo"
        }
      },
      "result": {
        "title": "{name}, {count} encontros combinam com você",
        "titleSingular": "{name}, 1 encontro combina com você",
        "subtitle": "Junte-se a mais de {userCount} pessoas online para trocas e apoio",
        "fallback": "Encontros para você",
        "fallbackSubtitle": "Ainda estamos categorizando os encontros. Enquanto isso, explore todos abaixo.",
        "join": "Participar",
        "explore": "Ver todos os encontros",
        "saving": "Estamos buscando os melhores encontros pra você"
      },
      "paraVoce": {
        "emptyTitle": "Personalizando seus encontros",
        "emptySubtitle": "Complete o questionário para ver encontros recomendados para você.",
        "startOnboarding": "Personalizar"
      }
    },
    "card": {
      "nextSession": "próxima sessão: {weekday} {time}"
    }
  },
  "trail": {
    "title": "Trilha",
    "subtitle": "Sua jornada de recuperação pessoal",
    "step": "Passo",
    "progress": "Progresso",
    "complete": "Completar",
    "completed": "Completado",
    "description": "Descrição",
    "progressLabel": "Concluído",
    "locked": "Bloqueado",
    "lockedMessage": "Complete o passo anterior para desbloquear",
    "lockButtonText": "Avançar",
    "reset": "Reiniciar Trilha",
    "resetConfirm": "Tem certeza que deseja reiniciar sua trilha?",
    "resetTitle": "Reiniciar Trilha?",
    "resetMessage": "Tem certeza que deseja reiniciar sua trilha? \n\nTodo o seu progresso será perdido e você voltará ao primeiro passo. Esta ação não pode ser desfeita.",
    "resetButton": "Sim, reiniciar",
    "resetting": "Reiniciando...",
    "cancelButton": "Cancelar",
    "intro": "Introdução",
    "introTitle": "A Trilha",
    "introSubtitle": "Entenda como funciona",
    "introModalTitle": "Como funciona a Trilha",
    "introModalMessage": "A Trilha é um caminho estruturado baseado no programa de recuperação.\n\nComplete cada passo em ordem para desbloquear o próximo. Cada passo contém conteúdo importante para sua jornada de recuperação.\n\nLeia com atenção e reflita sobre cada etapa antes de avançar.",
    "introButton": "Entendi",
    "lockedModalTitle": "Passo Bloqueado",
    "lockedModalMessage": "Este passo ainda está bloqueado. Complete os passos anteriores para desbloquear este conteúdo.",
    "lockedButton": "Entendi",
    "index": "Índice",
    "actions": {
      "exit": "Sair",
      "completeReading": "Completar leitura",
      "scrollToEnd": "Rolar até o final",
      "listen": "Escutar",
      "listening": "Ouvindo"
    },
    "csat": {
      "title": "O que você achou do conteúdo?"
    },
    "hints": {
      "readToComplete": "Leia até o final para completar este passo"
    },
    "accessibility": {
      "pausePlayer": "Pausar e abrir player",
      "listenStep": "Escutar passo",
      "audioPlusGated": "Áudio exclusivo Padrinho Plus — toque para conhecer"
    },
    "congratulations": {
      "message": "Parabéns! Você completou o",
      "completedStepMessage": "Parabéns! Você completou o passo {stepTitle} da trilha {trailName}"
    },
    "home": {
      "continueLearning": "Continue suas trilhas",
      "suggestedTrails": "Trilhas para você",
      "newTrails": "Novidades",
      "tabs": {
        "mine": "Iniciadas",
        "forYou": "Para você",
        "explore": "Explore"
      },
      "steps": "etapas",
      "favorite": "Favoritar",
      "favorited": "Salvo",
      "noMine": "Você ainda não iniciou nenhuma trilha",
      "noMineSubtitle": "Explore nossas trilhas e comece sua jornada",
      "noForYou": "Nenhuma trilha sugerida no momento",
      "otherTrails": "Outras trilhas",
      "started": "Em progresso",
      "iniciadas": {
        "emptyTitle": "Aprenda sobre a recuperação, inicie uma trilha",
        "emptyButton": "Explorar trilhas"
      }
    },
    "category": {
      "trails": "Trilhas",
      "empty": "Nenhuma trilha nesta categoria",
      "emptySubtitle": "Novas trilhas serão adicionadas em breve"
    },
    "start": {
      "title": "Iniciar trilha",
      "steps": "aulas",
      "button": "Iniciar trilha",
      "plusButton": "Torne-se Plus para acessar"
    },
    "audio": {
      "stepLabel": "{number}º Passo"
    }
  },
  "settings": {
    "title": "Configurações",
    "profile": "Perfil",
    "language": "Idioma",
    "notifications": "Notificações",
    "privacy": "Privacidade",
    "about": "Sobre",
    "logout": "Sair",
    "account": "Conta"
  },
  "communityProfile": {
    "memberSince": "Membro desde {date}",
    "follow": "Seguir",
    "following": "Seguindo",
    "message": "Mensagem",
    "posts": "Publicações",
    "now": "Agora",
    "minutesAgo": "{count}min",
    "hoursAgo": "{count}h",
    "yesterday": "Ontem",
    "daysAgo": "{count}d",
    "editProfile": "Editar perfil",
    "loading": "Carregando...",
    "noPostsYet": "Este usuário ainda não publicou nada.",
    "noPostsYetSelf": "Você ainda não fez nenhuma publicação.",
    "anonymous": "Anônimo",
    "statsFollowing": "Seguindo",
    "statsFriends": "Amigos",
    "statsPosts": "Posts",
    "options": "Opções",
    "editPost": "Editar post",
    "deletePost": "Excluir post",
    "postRemovedSuccess": "Post removido com sucesso",
    "postRemoveError": "Erro ao remover post",
    "recentlyParticipated": "Participou recentemente",
    "liveNow": "Ao vivo agora",
    "live": "Ao vivo",
    "todayAt": "Hoje às "
  },
  "communityChat": {
    "online": "Online",
    "offline": "Offline",
    "placeholder": "Digite uma mensagem...",
    "send": "Enviar"
  },
  "notifications": {
    "title": "Notificações",
    "settings": "Configurações de notificação",
    "adminOnly": "Esta área está disponível apenas para administradores.",
    "groups": {
      "today": "Hoje",
      "yesterday": "Ontem",
      "thisWeek": "Esta semana",
      "older": "Mais antigo"
    },
    "empty": {
      "title": "Você ainda não recebeu notificações"
    },
    "meetingReminder": {
      "withCategory": "Sua reunião de {category} do {meetingName} começa em 15 minutos"
    },
    "pushNotifications": "Notificações push",
    "pushDescription": "Receba lembretes e mensagens importantes da sua jornada de recuperação.",
    "whatYouWillReceive": "O que você vai receber",
    "receiveList": "Lembretes de reuniões, mensagens do seu padrinho, marcos de sobriedade e novidades da comunidade.",
    "privacyTitle": "Privacidade",
    "privacyNote": "Suas notificações são pessoais e seguras. Você pode desativá-las a qualquer momento nas configurações do dispositivo.",
    "statusAllowed": "Permitido",
    "statusDenied": "Negado",
    "statusSubscribed": "Inscrito",
    "statusNotSubscribed": "Não inscrito",
    "enabledSuccess": "Notificações ativadas com sucesso!",
    "permissionDenied": "Permissão de notificação negada. Você pode ativá-la nas configurações do dispositivo.",
    "disabled": "Notificações desativadas",
    "disabledAlertMessage": "Você não receberá mais notificações push. Pode reativá-las quando quiser.",
    "understood": "Entendi",
    "errorLoading": "Não foi possível carregar as configurações de notificação. Tente novamente.",
    "serviceUnavailable": "Serviço de notificações indisponível no momento. Tente novamente mais tarde.",
    "unsupportedEnvironment": "As notificações não são compatíveis com este ambiente.",
    "initializationFailed": "Falha ao inicializar as notificações. Tente novamente.",
    "webUnsupported": "As notificações não são compatíveis com a versão web.",
    "expoGoUnsupported": "As notificações não funcionam no Expo Go. Use um build de desenvolvimento.",
    "oneSignalNotConfigured": "O serviço de notificações não está configurado.",
    "expoGoWarningTitle": "Expo Go detectado",
    "expoGoWarningMessage": "As notificações push não estão disponíveis no Expo Go. Use um build de desenvolvimento ou produção para testá-las.",
    "webWarningTitle": "Versão web",
    "webWarningMessage": "As notificações push não são compatíveis com a versão web do aplicativo.",
    "oneSignalWarningTitle": "Notificações não configuradas",
    "oneSignalWarningMessage": "O serviço de notificações ainda não foi configurado neste ambiente."
  },
  "account": {
    "changeEmail": {
      "title": "Alterar email",
      "subtitle": "Digite o novo endereço de email para sua conta.",
      "subtitleStep1": "Para sua segurança, primeiro confirme sua senha atual.",
      "currentEmail": "Email atual:",
      "newEmail": "Novo email",
      "currentPassword": "Senha atual",
      "passwordPlaceholder": "Digite sua senha atual",
      "emailPlaceholder": "Digite seu novo email",
      "button": "Alterar email",
      "backToProfile": "Voltar ao perfil",
      "errorPassword": "Senha incorreta",
      "errorTooManyAttempts": "Muitas tentativas de login. Aguarde alguns minutos e tente novamente.",
      "errorEmailInUse": "Este email já está sendo usado por outra conta",
      "errorRateLimit": "Muitas tentativas de alteração de email. Aguarde alguns minutos antes de tentar novamente.",
      "errorGeneric": "Erro ao alterar email",
      "errorUserInfo": "Erro ao obter informações do usuário",
      "successTitle": "Email alterado",
      "successMessage": "Seu email foi alterado com sucesso!",
      "confirmationTitle": "Verificação enviada",
      "confirmationMessage": "Enviamos um email de confirmação para:",
      "confirmationInstructions": "Clique no link do email para confirmar a alteração. Você pode precisar verificar sua caixa de spam."
    },
    "changePassword": {
      "title": "Alterar senha",
      "subtitle": "Escolha uma nova senha forte para proteger sua conta.",
      "currentPassword": "Senha atual",
      "newPassword": "Nova senha",
      "confirmPassword": "Confirmar nova senha",
      "passwordPlaceholder": "Digite sua senha atual",
      "newPasswordPlaceholder": "Digite sua nova senha",
      "confirmPasswordPlaceholder": "Confirme sua nova senha",
      "requirements": "Sua senha deve ter:",
      "requirement1": "Mínimo 8 letras",
      "requirement2": "Uma letra maiúscula",
      "requirement3": "Uma letra minúscula",
      "requirement4": "Um número",
      "button": "Alterar senha",
      "buttonLoading": "Alterando...",
      "errorUserInfo": "Erro ao obter informações do usuário",
      "errorWrongPassword": "Senha atual incorreta",
      "errorPasswordMismatch": "As senhas não coincidem",
      "errorPasswordRequirements": "A nova senha não atende aos requisitos",
      "errorSamePassword": "A nova senha deve ser diferente da atual",
      "successTitle": "Senha alterada",
      "successMessage": "Sua senha foi alterada com sucesso!"
    },
    "changePhone": {
      "title": "Alterar telefone",
      "titleSet": "Definir telefone",
      "subtitle": "Para sua segurança, primeiro confirme sua senha atual.",
      "subtitleNew": "Digite o novo número de telefone que deseja usar.",
      "subtitleFirst": "Digite seu número de telefone para receber notificações importantes.",
      "currentPhone": "Telefone atual:",
      "label": "Número de telefone",
      "labelNew": "Novo número",
      "phoneNumber": "Número de telefone",
      "newPhoneNumber": "Novo número",
      "currentPassword": "Senha atual",
      "passwordPlaceholder": "Digite sua senha atual",
      "phonePlaceholder": "(11) 99999-9999",
      "phoneHint": "Digite apenas números, formataremos automaticamente",
      "button": "Alterar telefone",
      "buttonSet": "Definir telefone",
      "buttonLoading": "Salvando...",
      "buttonContinue": "Continuar",
      "verifying": "Verificando...",
      "errorPassword": "Senha incorreta",
      "errorPasswordRequired": "Digite sua senha atual",
      "errorInvalidPhone": "Por favor, insira um número válido",
      "errorSamePhone": "O novo número deve ser diferente do atual",
      "errorGeneric": "Erro ao alterar telefone",
      "successTitle": "Telefone alterado",
      "successMessage": "Seu número de telefone foi alterado com sucesso!"
    },
    "changeName": {
      "title": "Alterar apelido",
      "subtitle": "Altere seu apelido para personalizar sua experiência.",
      "label": "Novo apelido",
      "placeholder": "Digite seu novo apelido",
      "button": "Alterar apelido",
      "buttonLoading": "Salvando...",
      "errorRequired": "Por favor, digite um apelido",
      "errorUserNotFound": "Usuário não encontrado",
      "errorGeneric": "Não foi possível atualizar o apelido. Tente novamente.",
      "successMessage": "Apelido atualizado com sucesso!"
    },
    "changeUsername": {
      "title": "Nome de usuário",
      "subtitle": "Escolha um nome de usuário único para ser mencionado na comunidade.",
      "currentLabel": "Seu nome de usuário atual",
      "label": "Nome de usuário",
      "placeholder": "ex: joao.silva",
      "hint": "Use letras, números, pontos e underscore. Mín. 3, máx. 30 caracteres.",
      "checking": "Verificando...",
      "available": "Disponível",
      "unavailable": "Já está em uso",
      "button": "Salvar nome de usuário",
      "buttonLoading": "Salvando...",
      "errorRequired": "Por favor, escolha um nome de usuário",
      "errorUserNotFound": "Usuário não encontrado",
      "errorGeneric": "Não foi possível atualizar o nome de usuário. Tente novamente.",
      "successMessage": "Nome de usuário atualizado com sucesso!"
    },
    "deleteAccount": {
      "title": "Excluir conta",
      "question": "Tem certeza de que deseja excluir sua conta?",
      "warningTitle": "Ao excluir sua conta, você perderá:",
      "warningItem1": "Todos os seus dados de sobriedade e progresso",
      "warningItem2": "Histórico de anotações e reflexões",
      "warningItem3": "Acesso aos encontros online e comunidade",
      "warningItem4": "Configurações personalizadas do aplicativo",
      "warningItem5": "Acesso ao Bill (assistente virtual)",
      "warningFooter": "Esta ação não pode ser desfeita. Sua conta e todos os dados serão removidos permanentemente imediatamente.",
      "alternativeTitle": "Precisa de uma pausa?",
      "alternativeText": "Se você está passando por dificuldades, considere conversar com nossa equipe de apoio antes de excluir sua conta. Estamos aqui para ajudar.",
      "cancelButton": "Cancelar",
      "deleteButton": "Excluir conta",
      "deleteButtonLoading": "Processando...",
      "confirmTitle": "Confirmar exclusão",
      "confirmMessage": "Tem certeza de que deseja excluir sua conta? Todos os seus dados serão removidos imediatamente e esta ação não pode ser desfeita.",
      "confirmCancel": "Cancelar",
      "confirmDelete": "Excluir imediatamente",
      "errorUserNotFound": "Erro: usuário não encontrado",
      "errorSessionNotFound": "Erro: sessão não encontrada",
      "errorGeneric": "Erro ao excluir conta",
      "successMessage": "Conta excluída com sucesso"
    },
    "subscription": {
      "title": "Meu Plano",
      "pageTitle": "Meu plano",
      "basePlan": "Base",
      "activeBadge": "Ativo",
      "since": "desde",
      "planDescriptionPlus": "Acesso completo às funcionalidades premium do aplicativo e suporte prioritário.",
      "planDescriptionBase": "Acesso gratuito às funcionalidades do aplicativo e sua comunidade.",
      "upgradeTitle": "Padrinho Plus",
      "upgradeSubtitle": "A partir de R$ 29,90/mês",
      "providerText": "Veja todas as informações e canais de contato do seu provedor",
      "features": {
        "bill": {
          "title": "Bill, seu padrinho digital",
          "description": "Conversas inteligentes 24/7 para apoio e orientação (30 mensagens mensais)"
        },
        "billPlus": {
          "title": "Bill Plus",
          "description": "Seu padrinho digital ilimitado, conectado ao seu diário, relógio de sobriedade, check-ins em encontros para melhor te apoiar em sua trilha"
        },
        "meetings": {
          "title": "Encontros online",
          "description": "Reuniões online com múltiplas comunidades de anônimos"
        },
        "exclusiveMeetings": {
          "title": "Encontros exclusivos",
          "description": "Encontros ao vivo exclusivos para assinantes Plus"
        },
        "exclusiveTrails": {
          "title": "Trilhas exclusivas",
          "description": "Trilhas de recuperação exclusivas para assinantes Plus"
        },
        "diary": {
          "title": "Diário & Check-ins",
          "description": "Registre pensamentos, sentimentos e participações em encontros online"
        },
        "clock": {
          "title": "Relógio de sobriedade",
          "description": "Marque seu progresso em tempo e celebre cada conquista"
        },
        "progress": {
          "title": "Progresso em tempo real",
          "description": "Acompanhe sua evolução dia a dia"
        },
        "clinicConnection": {
          "title": "Conexão com clínicas",
          "description": "Comunicação direta com a sua clínica provedora"
        },
        "scheduling": {
          "title": "Agendamentos & Profissionais",
          "description": "Agendamento com profissionais para apoio em sua trilha"
        }
      },
      "securityText": "Todos os seus dados são protegidos e confidenciais",
      "termsLink": "Termos de Uso (EULA)",
      "upgrade": "Atualizar para Plus",
      "successUpgrade": "Sucesso!",
      "successUpgradeMessage": "Bem-vindo ao Padrinho Plus!",
      "error": "Erro",
      "errorMessage": "Não foi possível abrir a tela de assinatura.",
      "manageSubscription": "Gerenciar assinatura",
      "mySubscription": "Minha assinatura",
      "errorTermsOfUse": "Não foi possível abrir os Termos de Uso."
    },
    "provider": {
      "title": "Provedor",
      "phone": "Telefone",
      "whatsapp": "WhatsApp",
      "email": "E-mail",
      "website": "Site",
      "websiteTitle": "Site da Clínica",
      "instagram": "Instagram",
      "schedule": "Horário",
      "loading": "Carregando...",
      "noData": "Nenhuma informação de provedor disponível",
      "attendance": "Atendimento",
      "contactChannels": "Canais de contato",
      "address": "Endereço",
      "providerNotFound": "Provedor não encontrado"
    },
    "interests": {
      "title": "Meus interesses",
      "pageTitle": "Escolha os temas que você tem mais interesse",
      "subtitle": "Escolha pelo menos 3 tópicos de interesse",
      "button": "Atualizar meus interesses",
      "buttonLoading": "Salvando...",
      "errorMinimum": "Por favor, escolha pelo menos 3 tópicos de interesse.",
      "errorUserNotFound": "Erro: usuário não encontrado",
      "errorGeneric": "Erro ao atualizar interesses. Tente novamente.",
      "successMessage": "Interesses atualizados com sucesso!"
    },
    "languageSettings": {
      "title": "Linguagem",
      "button": "Escolher"
    }
  },
  "profile": {
    "title": "Perfil",
    "greeting": {
      "hello": "Olá, ",
      "wave": " 👋"
    },
    "sections": {
      "yourInfo": "Suas informações",
      "subscription": "Assinatura",
      "security": "Segurança",
      "app": "Aplicativo",
      "padrinho": "Padrinho"
    },
    "fields": {
      "nickname": "Apelido",
      "username": "Nome de usuário",
      "email": "E-mail",
      "phone": "Telefone",
      "notInformed": "Não informado",
      "myPlan": "Meu plano",
      "basePlan": "Base",
      "provider": "Provedor",
      "changePassword": "Alterar senha",
      "myInterests": "Meus interesses",
      "myInterestsSubtitle": "Configure o que você vê no app",
      "language": "Linguagem",
      "widget": "Widget",
      "widgetSubtitle": "Visualize o widget da tela inicial"
    },
    "languages": {
      "pt": "Português (Brasil)",
      "en": "English (United States)",
      "es": "Español (España)"
    },
    "upgrade": {
      "title": "Padrinho Plus",
      "subtitle": "A partir de R$ 29,90/mês"
    },
    "csat": {
      "title": "Como está sua experiência no app?",
      "subtitle": "Conta pra gente"
    },
    "logout": {
      "title": "Sair",
      "message": "Tem certeza de que deseja sair da sua conta?",
      "cancel": "Cancelar",
      "confirm": "Sair"
    },
    "deleteAccount": {
      "label": "Excluir minha conta"
    },
    "defaults": {
      "userName": "Usuário"
    },
    "share": {
      "inviteTitle": "Convite para o Padrinho",
      "shareError": "Erro ao compartilhar",
      "inviteMessage": "Oi! Descobri um app incrível que está me ajudando muito na minha recuperação. Chama Padrinho e tem encontros online, relógio de sobriedade e muito mais. Baixa aí: https://www.padrinho.app/downloads"
    },
    "cards": {
      "compass": {
        "tag": "Bússola",
        "title": "A informação é o norte para sua recuperação!",
        "subtitle": "Acesse o blog"
      },
      "community": {
        "tag": "Comunidade",
        "title": "Compartilhe sua história e experiência com outros membros",
        "subtitle": "Entrar no WhatsApp"
      },
      "podcast": {
        "tag": "Pé na Trilha",
        "title": "Conteúdos em áudio para complementar o seu programa",
        "subtitle": "Ouça no Spotify"
      },
      "invite": {
        "title": "Convide alguém para o Padrinho",
        "subtitle": "Compartilhe o convite"
      }
    },
    "menu": {
      "title": "Menu",
      "hello": "Olá,",
      "moreContent": "Mais conteúdos",
      "diaryTitle": "Diário",
      "diarySubtitle": "Anotações, sentimentos e mensagens"
    },
    "errors": {
      "loadProfile": "Erro ao carregar perfil",
      "retry": "Tentar Novamente",
      "backToLogin": "Voltar ao Login",
      "userNotFound": "Usuário não encontrado",
      "userDataError": "Não foi possível carregar os dados do usuário",
      "makeLogin": "Fazer Login"
    },
    "toasts": {
      "phoneChangedSuccess": "Telefone alterado com sucesso!",
      "authError": "Erro de autenticação. Tente novamente.",
      "noImageSelected": "Nenhuma imagem selecionada",
      "invalidFile": "Arquivo inválido",
      "uploadingPhoto": "Enviando foto...",
      "uploadFailed": "Não foi possível fazer o upload da imagem",
      "photoUpdated": "Foto de perfil atualizada!",
      "permissionRequired": "Permissão necessária para acessar a galeria",
      "connectionError": "Erro de conexão. Tente novamente.",
      "permissionDenied": "Permissão negada para acessar galeria",
      "photoUpdateError": "Erro ao alterar foto do perfil",
      "unexpectedError": "Erro inesperado. Tente novamente.",
      "nameUpdateError": "Erro ao atualizar nome",
      "nameSaved": "Nome salvo com sucesso!",
      "logoutError": "Erro ao sair da conta",
      "plusUpgradeSuccess": "Parabéns! Você agora tem acesso ao Padrinho Plus!",
      "paywallError": "Não foi possível abrir a tela de assinatura.",
      "subscriptionManagementError": "Não foi possível abrir o gerenciamento de assinatura."
    }
  },
  "common": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Deletar",
    "edit": "Editar",
    "close": "Fechar",
    "back": "Voltar",
    "next": "Próximo",
    "loading": "Carregando...",
    "error": "Erro",
    "success": "Sucesso!",
    "confirm": "Confirmar",
    "yes": "Sim",
    "no": "Não",
    "and": "e",
    "of": "de",
    "apply": "Aplicar",
    "clearFilters": "Limpar filtros",
    "now": "Agora",
    "today": "Hoje",
    "tomorrow": "Amanhã",
    "yesterday": "Ontem",
    "months": {
      "january": "janeiro",
      "february": "fevereiro",
      "march": "março",
      "april": "abril",
      "may": "maio",
      "june": "junho",
      "july": "julho",
      "august": "agosto",
      "september": "setembro",
      "october": "outubro",
      "november": "novembro",
      "december": "dezembro"
    },
    "weekdays": {
      "short": {
        "sunday": "Dom",
        "monday": "Seg",
        "tuesday": "Ter",
        "wednesday": "Qua",
        "thursday": "Qui",
        "friday": "Sex",
        "saturday": "Sáb"
      },
      "long": {
        "sunday": "Domingo",
        "monday": "Segunda-feira",
        "tuesday": "Terça-feira",
        "wednesday": "Quarta-feira",
        "thursday": "Quinta-feira",
        "friday": "Sexta-feira",
        "saturday": "Sábado"
      }
    },
    "periods": {
      "morning": "Manhã",
      "afternoon": "Tarde",
      "evening": "Noite"
    },
    "categories": {
      "supportGroup": "Grupo de Apoio",
      "workshop": "Workshop",
      "meditation": "Meditação",
      "therapy": "Terapia",
      "sharing": "Partilha",
      "reuniaoNovos": "Reunião para Novos",
      "reuniaoPartilhas": "Reunião de Partilhas",
      "reuniaoTematica": "Reunião Temática",
      "reuniaoEstudoLiteratura": "Estudo de Literatura",
      "reuniaoAteusAgnosticos": "Ateus e Agnósticos",
      "reuniaoLgbtqiapn": "LGBTQIAPN+",
      "reuniaoCodependentes": "Codependentes",
      "reuniaoPassos": "Reunião de Passos",
      "reuniaoTradicoes": "Reunião de Tradições"
    },
    "alert": {
      "errorTitle": "Erro",
      "successTitle": "Sucesso!",
      "warningTitle": "Aviso",
      "infoTitle": "Informação"
    }
  },
  "audioPlayer": {
    "exit": "Sair",
    "stepLabel": "º Passo",
    "title": "Áudio"
  },
  "patient": {
    "welcome": {
      "loading": "Carregando...",
      "configurationRequired": "Configuração Necessária",
      "configurationRequiredMessage": "Você precisa configurar uma senha antes de continuar.",
      "goToSetPassword": "Ir para configuração de senha"
    }
  },
  "admin": {
    "errors": {
      "loadConfig": "Não foi possível carregar a configuração atual.",
      "saveChanges": "Não foi possível salvar as alterações. Tente novamente."
    },
    "alerts": {
      "exitWithoutSaving": "Sair sem salvar"
    }
  },
  "calendar": {
    "title": "Diário de sentimentos",
    "congratsGreeting": "Parabéns!",
    "congratsMiddle": " Você registrou ",
    "congratsCountUnit": "sentimentos",
    "congratsEnd": " nos últimos 7 dias"
  },
  "filters": {
    "author": {
      "you": "Você",
      "bill": "Bill"
    },
    "period": {
      "last7days": "Últimos 7 dias",
      "last15days": "Últimos 15 dias",
      "last30days": "Últimos 30 dias"
    },
    "time": "Horário",
    "dayOfWeek": "Dia da semana"
  },
  "group": {
    "title": "Grupo",
    "filters": {
      "time": "Horário",
      "dayOfWeek": "Dia da semana",
      "category": "Categoria"
    },
    "errors": {
      "notFound": "Grupo não encontrado",
      "noMeetings": "Nenhum encontro encontrado"
    },
    "liveNow": "Ao vivo agora",
    "todayAt": "Hoje às"
  },
  "meeting": {
    "liveNow": "Ao vivo agora",
    "startsInMinutes": "Começa em {minutes} {unit}",
    "startsInHours": "Começa em {hours} {unit}",
    "startsInHoursMinutes": "Começa em {hours}h{minutes}",
    "endedMinutesAgo": "Acabou há {minutes} {unit}",
    "endedHoursAgo": "Acabou há {hours}h{minutes}",
    "timeError": "Erro ao calcular horário",
    "timeNotSpecified": "Horário não especificado",
    "notSpecified": "Não especificado",
    "everyDay": "Todos os dias",
    "mondayToFriday": "Segunda a sexta",
    "weekends": "Fins de semana",
    "everyDayName": "Toda {day}",
    "and": "e",
    "andOthers": "e outros",
    "minute": "minuto",
    "minutes": "minutos",
    "hour": "hora",
    "hours": "horas",
    "errors": {
      "loadFailed": "Não foi possível carregar as informações do encontro",
      "loginRequired": "É necessário fazer login para entrar no encontro",
      "linkUnavailable": "Link do encontro não disponível"
    }
  },
  "email": {
    "errors": {
      "notFound": "E-mail não encontrado",
      "resendFailed": "Erro ao reenviar link. Tente novamente.",
      "unexpectedError": "Erro inesperado. Tente novamente."
    },
    "success": {
      "resent": "Link reenviado com sucesso!"
    }
  },
  "community": {
    "header": {
      "title": "Comunidade"
    },
    "tabs": {
      "forYou": "Para você",
      "following": "Seguindo"
    },
    "author": {
      "anonymous": "Anônimo",
      "default": "Usuário"
    },
    "emptyState": {
      "title": "Suas pegadas ficam marcadas aqui na comunidade!",
      "subtitle": "Deixe sua mensagem para os membros que ainda estão chegando"
    },
    "actions": {
      "options": "Opções",
      "editPost": "Editar post",
      "deletePost": "Excluir post"
    },
    "toast": {
      "postRemoved": "Post removido com sucesso",
      "postRemoveError": "Erro ao remover post",
      "postUpdated": "Post atualizado com sucesso",
      "postUpdateError": "Erro ao atualizar post"
    },
    "timestamp": {
      "now": "Agora",
      "yesterday": "Ontem"
    },
    "newPost": {
      "titleComment": "Novo comentário",
      "titlePost": "Novo depoimento",
      "editTitle": "Editar post",
      "publish": "Publicar",
      "save": "Salvar",
      "cancel": "Cancelar",
      "addTopic": "Adicionar tópico",
      "topicsCount": "{count} tópicos",
      "placeholder": "O que está em sua mente agora?",
      "defaultUser": "Usuário"
    },
    "post": {
      "headerTitle": "Comunidade",
      "firstToEncourage": "Seja o primeiro a encorajar!",
      "commentPlaceholder": "Escreva um encorajamento...",
      "options": "Opções",
      "editPost": "Editar post",
      "deletePost": "Excluir post",
      "postRemoved": "Post removido com sucesso",
      "postRemoveError": "Erro ao remover post",
      "anonymous": "Anônimo",
      "defaultAuthor": "Usuário",
      "timestampNow": "Agora"
    },
    "publishing": {
      "publishing": "Publicando...",
      "error": "Não foi possível publicar",
      "success": "Publicado com sucesso!"
    },
    "topics": {
      "title": "Tópicos",
      "save": "Salvar",
      "searchPlaceholder": "Buscar tópico…",
      "notFound": "Nenhum tópico encontrado",
      "labels": {
        "Abstinência": "Abstinência",
        "Adultos 60+": "Adultos 60+",
        "Álcool": "Álcool",
        "Ansiedade": "Ansiedade",
        "Apadrinhamento": "Apadrinhamento",
        "Autocompaixão": "Autocompaixão",
        "Autoconhecimento": "Autoconhecimento",
        "Autocontrole": "Autocontrole",
        "Bariátrica": "Bariátrica",
        "Burnout": "Burnout",
        "Comunicação": "Comunicação",
        "Compras Compulsivas": "Compras Compulsivas",
        "Dependência Digital": "Dependência Digital",
        "Depressão": "Depressão",
        "Drogas / Psicoativos": "Drogas / Psicoativos",
        "Emoções": "Emoções",
        "Estresse": "Estresse",
        "Família": "Família",
        "Feminilidade": "Feminilidade",
        "Gatilhos": "Gatilhos",
        "Internação": "Internação",
        "Jogos": "Jogos",
        "Juventude": "Juventude",
        "LGBT+": "LGBT+",
        "Limites": "Limites",
        "Lucidez": "Lucidez",
        "Masculinidade": "Masculinidade",
        "Maternidade": "Maternidade",
        "Neurodivergência": "Neurodivergência",
        "Novos na Recuperação": "Novos na Recuperação",
        "Outras Dependências": "Outras Dependências",
        "Paternidade": "Paternidade",
        "Pornografia": "Pornografia",
        "Prevenção de Recaída": "Prevenção de Recaída",
        "Psiquiatria & Medicação": "Psiquiatria & Medicação",
        "Raiva": "Raiva",
        "Recomeços": "Recomeços",
        "Rede de Apoio": "Rede de Apoio",
        "Redes Sociais": "Redes Sociais",
        "Relacionamentos": "Relacionamentos",
        "Ressaca": "Ressaca",
        "Rotina de Sobriedade": "Rotina de Sobriedade",
        "Sexo": "Sexo",
        "Sobriedade Longa": "Sobriedade Longa",
        "Solidão": "Solidão",
        "Terapia": "Terapia",
        "Transtornos Alimentares": "Transtornos Alimentares",
        "Tratamento": "Tratamento",
        "Vergonha & Culpa": "Vergonha & Culpa",
        "Vida Sexual Saudável": "Vida Sexual Saudável"
      }
    }
  },
  "padrinho": {
    "website": "Site",
    "privacy": "Políticas de uso e privacidade",
    "help": "Ajuda"
  },
  "csat": {
    "pageTitle": "Avaliação",
    "title": "Avalie sua experiência no aplicativo Padrinho",
    "starsInstruction": "Escolha de 1 a 5 estrelas para classificar",
    "topicsTitles": {
      "negative": "O que está errado?",
      "neutral": "O que pode melhorar?",
      "positive": "Do que você gostou?"
    },
    "topics": {
      "negative": {
        "crashes": "Travamentos",
        "slowPerformance": "Lentidão",
        "confusingNavigation": "Navegação confusa",
        "billResponses": "Respostas do Bill",
        "notifications": "Notificações",
        "design": "Design",
        "meetings": "Encontros",
        "trail": "Trilha dos 12 passos",
        "diary": "Diário emocional"
      },
      "neutral": {
        "navigation": "Navegação",
        "billQuality": "Qualidade do Bill",
        "design": "Design",
        "performance": "Desempenho",
        "notifications": "Notificações",
        "meetings": "Encontros",
        "trail": "Trilha dos 12 passos",
        "diary": "Diário emocional",
        "community": "Comunidade"
      },
      "positive": {
        "easeOfUse": "Fácil de usar",
        "billHelp": "Ajuda do Bill",
        "design": "Design bonito",
        "meetings": "Encontros",
        "trail": "Trilha dos 12 passos",
        "diary": "Diário emocional",
        "sobrietyClock": "Relógio de sobriedade",
        "community": "Comunidade",
        "notifications": "Notificações"
      },
      "other": "Outro"
    },
    "commentTitle": "Deixe seu comentário",
    "commentPlaceholder": "Conte mais sobre sua experiência...",
    "submit": "Enviar avaliação",
    "submitting": "Enviando...",
    "alerts": {
      "selectRating": "Por favor, selecione uma nota",
      "error": "Erro ao enviar avaliação. Tente novamente."
    },
    "success": {
      "title": "Obrigado pelo feedback!",
      "subtitle": "Sua avaliação foi enviada com sucesso. Ela é muito importante para continuarmos melhorando o app.",
      "button": "Voltar"
    },
    "callTitle": "Avalie sua experiência no encontro",
    "callTopics": {
      "negative": {
        "audioQuality": "Qualidade do áudio",
        "videoQuality": "Qualidade do vídeo",
        "connectionDrops": "Quedas de conexão",
        "sponsorPreparedness": "Preparo do padrinho",
        "scheduling": "Horário"
      },
      "neutral": {
        "audioQuality": "Qualidade do áudio",
        "videoQuality": "Qualidade do vídeo",
        "sponsorPreparedness": "Preparo do padrinho",
        "callDuration": "Duração da chamada",
        "scheduling": "Horário"
      },
      "positive": {
        "clearAudio": "Áudio claro",
        "clearVideo": "Vídeo nítido",
        "sponsorHelp": "Ajuda do padrinho",
        "easyToConnect": "Fácil de conectar",
        "callDuration": "Duração da chamada"
      }
    },
    "trailTitle": "O que você achou do conteúdo?",
    "trailTopics": {
      "negative": {
        "contentDifficult": "Difícil de entender",
        "contentNotRelevant": "Pouco relevante pra mim",
        "contentTooShort": "Curto demais",
        "contentTooLong": "Longo demais",
        "contentFewExamples": "Faltam exemplos práticos",
        "audioQuality": "Qualidade do áudio"
      },
      "neutral": {
        "contentDepth": "Profundidade do conteúdo",
        "contentPace": "Ritmo da leitura",
        "contentExamples": "Exemplos práticos",
        "contentLanguage": "Linguagem usada",
        "audioExperience": "Experiência com o áudio"
      },
      "positive": {
        "contentClarity": "Conteúdo claro",
        "contentHelpful": "Me ajudou na recuperação",
        "contentRelevant": "Conteúdo relevante",
        "contentExamples": "Bons exemplos práticos",
        "audioQuality": "Áudio bem feito"
      }
    }
  },
  "postCallCsat": {
    "sessionEnded": "Sessão encerrada",
    "headline": "Conta pra gente como foi sua experiência",
    "rate": "Avaliar minha experiência",
    "skip": "Deixar para depois"
  },
  "appointments": {
    "title": "Agendamentos",
    "upcoming": "Próximas sessões",
    "history": "Sessões anteriores",
    "discoveryTitle": "Encontre os profissionais corretos para te apoiar em sua trilha",
    "discoveryChips": "Abstinência,Masculinidade,Dinheiro,Internação,Experiência",
    "findProfessionals": "Encontrar profissionais",
    "discoveryError": "Não foi possível carregar os profissionais agora.",
    "noPastInline": "Você não possui agendamentos anteriores",
    "newAppointment": "Novo agendamento",
    "contextTitle": "Opções",
    "reschedule": "Reagendar",
    "cancel": "Cancelar",
    "cancelAppointment": "Cancelar agendamento",
    "cancelTitle": "Cancelar agendamento",
    "cancelMessage": "Tem certeza que deseja cancelar este agendamento?",
    "cancelSuccess": "Agendamento cancelado com sucesso",
    "cancelError": "Erro ao cancelar agendamento",
    "changeWindowDisclaimer": "O cancelamento ou reagendamento só pode ser realizado até 24 horas antes da sessão. Depois desse período, não é mais possível cancelar ou reagendar.",
    "changeWindowClosed": "Não é possível cancelar ou reagendar dentro de 24 horas da sessão.",
    "loadError": "Erro ao carregar agendamentos",
    "pendingPayment": "Pagamento pendente",
    "completePayment": "Concluir pagamento"
  },
  "sponsors": {
    "details": {
      "crp": "CRP",
      "session": "Sessão",
      "price": "Valor por sessão",
      "durationMinutes": "{minutes} minutos",
      "sessionDuration": "Sessão de {minutes} minutos"
    },
    "scheduleSession": "Agendar sessão",
    "profile": {
      "findSponsorTitle": "Encontre um profissional",
      "findSponsorSubtitle": "Agende um horário",
      "scheduledTitle": "Agendamentos",
      "role": "Meu Padrinho",
      "scheduledFor": "Agendamento para",
      "at": "às",
      "scheduledDate": "Agendamento para {{date}} às {{time}}",
      "whatsappButton": "Enviar mensagem",
      "saveToCalendar": "Salvar na agenda",
      "joinRoom": "Entrar na sessão",
      "joinRoomLoading": "Abrindo sessão…",
      "joinRoomTooEarly": "Disponível 15 min antes",
      "joinRoomError": "Não foi possível abrir a sessão. Tente de novo em alguns segundos.",
      "menuTitle": "Opções",
      "cancelAppointment": "Cancelar agendamento",
      "cancelTitle": "Cancelar agendamento",
      "cancelMessage": "Tem certeza que deseja cancelar este agendamento?",
      "cancelSuccess": "Agendamento cancelado com sucesso",
      "cancelError": "Erro ao cancelar agendamento",
      "rescheduleSession": "Reagendar sessão",
      "rescheduleTitle": "Reagendar sessão",
      "rescheduleSuccess": "Sessão reagendada com sucesso!",
      "rescheduleError": "Erro ao reagendar a sessão",
      "reschedulePastError": "Não é possível reagendar uma sessão que já passou",
      "rescheduleSlotTaken": "Este horário não está mais disponível",
      "changeWindowClosed": "Não é possível reagendar dentro de 24 horas da sessão."
    },
    "list": {
      "title": "Profissionais",
      "subtitle": "Aqui estão algumas sugestões de Padrinhos e Madrinhas para você",
      "padrinho": "Padrinho",
      "madrinha": "Madrinha",
      "viewAgendaButton": "Agendar sessão",
      "loading": "Carregando sugestões...",
      "error": "Erro ao carregar padrinhos",
      "empty": "Nenhum padrinho disponível no momento"
    },
    "agenda": {
      "title": "Agenda",
      "sessionDuration": "Sessões de 45 minutos",
      "schedules": "Agendas de",
      "to": "a",
      "dateRange": "Agendas de {{startDate}} a {{endDate}}",
      "selectTime": "{{date}} às {{time}}",
      "confirmButton": "Confirmar horário",
      "loading": "Carregando agenda...",
      "error": "Erro ao carregar horários",
      "noSlots": "Nenhum horário disponível",
      "rescheduleConfirmButton": "Confirmar reagendamento",
      "rescheduling": "Reagendando..."
    },
    "phone": {
      "headerTitle": "Contato",
      "title": "Confirme seu celular",
      "subtitle": "Este será o meio de comunicação do profissional com você se necessário.",
      "placeholder": "( __ ) _____ - ____",
      "confirmButton": "Confirmar e agendar",
      "confirming": "Confirmando...",
      "saveError": "Não foi possível salvar seu celular. Tente novamente."
    },
    "payment": {
      "headerTitle": "Pagamento",
      "title": "Finalizar pagamento",
      "scheduledFor": "Agendamento para {date} às {time}",
      "methodTitle": "Forma de pagamento",
      "interimNotice": "A cobrança online ainda não será realizada. Nesta etapa, você só confirma o agendamento.",
      "pix": "Pix",
      "card": "Cartão",
      "comingSoon": "Em breve",
      "amountLabel": "Valor a ser pago",
      "priceUnavailable": "Não foi possível carregar o valor",
      "confirmButton": "Finalizar pagamento",
      "invalidContext": "Não foi possível validar os dados do agendamento. Volte e escolha o horário novamente.",
      "phoneMissing": "Confirme seu celular novamente antes de agendar.",
      "checkoutError": "Não foi possível concluir o pagamento. Seu horário será liberado se o pagamento não for confirmado.",
      "finalizationPending": "O pagamento ainda está sendo confirmado. Consulte seus agendamentos em alguns instantes.",
      "refundStartedTitle": "Não conseguimos confirmar sua sessão",
      "refundStartedMessage": "O pagamento foi aprovado, mas o horário não pôde ser reservado. O estorno já foi iniciado automaticamente e você não precisa fazer nada.",
      "refundCompletedTitle": "Pagamento estornado",
      "refundCompletedMessage": "O pagamento foi estornado. O prazo para o valor aparecer depende da sua instituição financeira."
    },
    "success": {
      "header": "Agendamento",
      "title": "Agendamento realizado com sucesso",
      "subtitlePrefix": "Avisaremos",
      "subtitleSuffix": "do seu agendamento",
      "button": "Ver meus agendamentos",
      "buttonCsat": "Avaliar experiência",
      "rescheduleHeader": "Reagendamento",
      "rescheduleTitle": "Sessão reagendada com sucesso",
      "rescheduleSubtitlePrefix": "Avisaremos",
      "rescheduleSubtitleSuffix": "sobre o novo horário",
      "rescheduleButton": "Ver meus agendamentos"
    },
    "enableNotifications": {
      "header": "Notificações",
      "title": "Ative suas notificações!",
      "subtitle": "Assim nós conseguimos te avisar sobre a sua conversa com {{sponsorName}}",
      "settingsButton": "Ir para as configurações",
      "skipButton": "Agora não!"
    },
    "weekdays": {
      "monday": "Segunda-feira",
      "tuesday": "Terça-feira",
      "wednesday": "Quarta-feira",
      "thursday": "Quinta-feira",
      "friday": "Sexta-feira",
      "saturday": "Sábado",
      "sunday": "Domingo"
    },
    "errors": {
      "title": "Erro",
      "notPlusUser": "Este recurso é exclusivo para assinantes Padrinho Plus",
      "loadError": "Erro ao carregar informações",
      "scheduleError": "Erro ao agendar horário",
      "slotTaken": "Este horário não está mais disponível",
      "invalidPhone": "Por favor, informe um número de telefone válido"
    }
  },
  "biometric": {
    "loginButton": "Entrar com Face ID",
    "loginButtonFingerprint": "Entrar com digital",
    "enableTitle": "Entrar mais rápido",
    "enableDescription": "Use sua biometria para entrar no Padrinho sem digitar sua senha.",
    "enableButton": "Ativar biometria",
    "notNow": "Agora não",
    "settingTitle": "Face ID",
    "settingTitleFingerprint": "Biometria",
    "settingSubtitle": "Entre sem digitar sua senha",
    "disableConfirmTitle": "Desativar biometria?",
    "disableConfirmMessage": "Você precisará digitar sua senha para entrar.",
    "disableConfirmYes": "Desativar",
    "disableConfirmNo": "Cancelar",
    "authReason": "Confirme sua identidade para entrar no Padrinho",
    "unavailable": "Não disponível neste dispositivo"
  },
  "consent": {
    "updateTitle": "Termos Atualizados",
    "updateMessage": "Nossos Termos de Uso e Política de Privacidade foram atualizados. Por favor, revise e aceite para continuar usando o aplicativo.",
    "viewTerms": "Ler Termos e Política de Privacidade",
    "acceptCheckbox": "Li e aceito os Termos de Uso e a Política de Privacidade atualizados",
    "acceptButton": "Aceitar e Continuar",
    "acceptingButton": "Registrando...",
    "errorTitle": "Erro",
    "errorMessage": "Não foi possível registrar seu consentimento. Por favor, tente novamente."
  },
  "widget": {
    "preview": {
      "title": "Widget Preview",
      "label": "Widget Médio (349 × 164)",
      "labelSmall": "Widget Pequeno (164 × 164)"
    },
    "guide": {
      "title": "Widget na tela inicial",
      "subtitle": "Veja seu contador de sobriedade diretamente na tela inicial do celular.",
      "done": "Entendi",
      "ios": {
        "step1": "Pressione e segure uma área vazia da tela inicial",
        "step2": "Toque no botão \"+\" no canto superior esquerdo",
        "step3": "Pesquise por \"Padrinho\" na barra de busca",
        "step4": "Escolha o tamanho do widget que preferir",
        "step5": "Toque em \"Adicionar Widget\" para confirmar"
      },
      "android": {
        "step1": "Pressione e segure uma área vazia da tela inicial",
        "step2": "Toque em \"Widgets\" no menu que aparecer",
        "step3": "Procure por \"Padrinho\" na lista de widgets",
        "step4": "Pressione e segure o widget e arraste para a tela inicial"
      }
    }
  },
  "usernamePrompt": {
    "title": "Seu @usuário foi criado",
    "description": "Outros membros da comunidade podem te mencionar nos posts usando seu handle.",
    "gotIt": "Entendi",
    "customize": "Personalizar handle"
  },
  "missoes": {
    "tabLabel": "Missões",
    "todayHeading": "Suas missões de hoje",
    "todayDateLabel": "Hoje, {date}",
    "empty": "Nenhuma missão hoje. Volte amanhã.",
    "goalCard": {
      "title": "Meu objetivo",
      "stagePill": "Fase {stageNumber} · {stageName}",
      "askBill": "Pergunte ao Bill",
      "sobrietyFooter": "Você está a {days} dias em sobriedade",
      "setSobriety": "Definir tempo de sobriedade"
    },
    "encontros": {
      "heading": "Encontros",
      "weekIntro": "Sua presença nos últimos 7 dias",
      "encouragement": "Parabéns! Você esteve em <b>{count} encontros</b> nos últimos 7 dias",
      "encouragementOne": "Parabéns! Você esteve em <b>1 encontro</b> nos últimos 7 dias",
      "encouragementZero": "Você ainda não participou de encontros nesta semana"
    },
    "weekdays": {
      "sun": "Dom",
      "mon": "Seg",
      "tue": "Ter",
      "wed": "Qua",
      "thu": "Qui",
      "fri": "Sex",
      "sat": "Sáb"
    },
    "missions": {
      "participar_encontro": {
        "label": "Participar de um encontro",
        "helper": "Marque presença em uma reunião"
      },
      "registrar_diario_sentimentos": {
        "label": "Registrar no diário de sentimentos",
        "helper": "Anote uma emoção do dia"
      },
      "progredir_trilha": {
        "label": "Progredir em uma trilha",
        "helper": "Continue de onde parou"
      },
      "apoiar_membro_comunidade": {
        "label": "Apoiar um membro da comunidade",
        "helper": "Reaja ou comente em um post"
      },
      "publicar_comunidade": {
        "label": "Publicar na comunidade",
        "helper": "Compartilhe algo com quem caminha junto"
      },
      "doneA11y": "concluída"
    },
    "history": {
      "heading": "Histórico",
      "yesterdayDateLabel": "Ontem, {date}",
      "dateNamed": "{date}",
      "week": "Semana",
      "month": "1 Mês",
      "threeMonths": "3 Meses",
      "sixMonths": "6 Meses",
      "twelveMonths": "12 Meses",
      "view": "Visualizar",
      "close": "Fechar",
      "completedSummary": "Você completou {done} de {total} missões",
      "loading": "Carregando...",
      "loadFailed": "Não foi possível carregar este dia.",
      "relapseMessage": "Houve um recomeço, não desista!",
      "supports": {
        "one": {
          "bold": "1 pessoa",
          "suffix": " recebeu seu suporte"
        },
        "many": {
          "bold": "{count} pessoas",
          "suffix": " receberam seu suporte"
        }
      },
      "posts": {
        "many": "Você compartilhou {count} reflexões na comunidade",
        "anonymous": "Anônimo",
        "you": "Você"
      },
      "timeAgo": {
        "minute": "há {n} min",
        "hour": "há {n} h",
        "day": "há {n} d"
      }
    },
    "origin": {
      "youArrivedAt": "Você chegou ao Padrinho"
    },
    "errors": {
      "loadFailed": "Não conseguimos carregar suas missões agora.",
      "retry": "Tentar novamente"
    }
  },
  "stageTransition": {
    "eyebrow": "NOVA FASE",
    "title": "Você avançou para {stageName}",
    "body": "{stageDescription}",
    "transitionLabel": "{from} → {to}",
    "primaryCta": "Continuar minha jornada",
    "secondaryCta": "Mais tarde"
  },
  "currentStage": {
    "headerTitle": "Seu estágio",
    "eyebrow": "MINHA ETAPA ATUAL",
    "stageLabel": "Etapa {n} de 5",
    "primaryCta": "Ok, entendi"
  },
  "changeGoal": {
    "headerTitle": "Objetivo",
    "bodyTitle": "Defina bem o seu principal objetivo dentro do aplicativo",
    "cta": "Definir meu objetivo"
  },
  "billAsk": {
    "goalQuestion": "Como posso desenvolver o meu objetivo de \"{goal}\"?",
    "stageQuestion": "Como posso evoluir na minha etapa atual de recuperação?"
  },
  "recoveryStages": {
    "1": {
      "name": "Início",
      "description": "Você está na fase inicial. Mantenha-se perto de apoio intensivo, isso é essencial agora.",
      "defaultGoal": "Cuidar de mim hoje, um momento de cada vez."
    },
    "2": {
      "name": "Fundação",
      "description": "Você está nos primeiros passos. A base ainda é frágil; engajamento diário faz toda a diferença.",
      "defaultGoal": "Construir uma rotina que sustente minha sobriedade."
    },
    "3": {
      "name": "Desenvolvimento",
      "description": "Padrões saudáveis começam a se formar. Manter a consistência é o foco desta fase.",
      "defaultGoal": "Aprofundar o que já funciona e descobrir novas forças."
    },
    "4": {
      "name": "Fortalecimento",
      "description": "Progresso sólido e confiança crescente. Continue reforçando os hábitos conquistados.",
      "defaultGoal": "Manter o que dá certo e cuidar dos vínculos importantes."
    },
    "5": {
      "name": "Manutenção",
      "description": "Sua recuperação está estável. É hora de reconstruir as áreas da vida afetadas pela dependência.",
      "defaultGoal": "Sustentar minha sobriedade e contribuir com quem está começando."
    }
  }
}
